@file:OptIn(InternalResourceApi::class)

package com.hyperether.goodjob.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/com.hyperether.goodjob.resources/"

public val Res.string.feedback: StringResource by lazy {
      StringResource("string:feedback", "feedback", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12071, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10567, 28),
      ))
    }

public val Res.string.file_added: StringResource by lazy {
      StringResource("string:file_added", "file_added", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12100, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10596, 50),
      ))
    }

public val Res.string.file_deleted: StringResource by lazy {
      StringResource("string:file_deleted", "file_deleted", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12167, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10647, 56),
      ))
    }

public val Res.string.file_empty: StringResource by lazy {
      StringResource("string:file_empty", "file_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12228, 334),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10704, 262),
      ))
    }

public val Res.string.files: StringResource by lazy {
      StringResource("string:files", "files", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12813, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11165, 21),
      ))
    }

public val Res.string.files_notes: StringResource by lazy {
      StringResource("string:files_notes", "files_notes", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12563, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10967, 39),
      ))
    }

public val Res.string.files_skipped_message: StringResource by lazy {
      StringResource("string:files_skipped_message", "files_skipped_message", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12607, 125),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11007, 89),
      ))
    }

public val Res.string.files_skipped_title: StringResource by lazy {
      StringResource("string:files_skipped_title", "files_skipped_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12733, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11097, 67),
      ))
    }

public val Res.string.filter: StringResource by lazy {
      StringResource("string:filter", "filter", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12896, 22),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11244, 22),
      ))
    }

public val Res.string.filter_empty: StringResource by lazy {
      StringResource("string:filter_empty", "filter_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12839, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11187, 56),
      ))
    }

public val Res.string.final_inspection: StringResource by lazy {
      StringResource("string:final_inspection", "final_inspection", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13099, 160),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11423, 144),
      ))
    }

public val Res.string.final_inspection_desc: StringResource by lazy {
      StringResource("string:final_inspection_desc", "final_inspection_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 12919, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11267, 73),
      ))
    }

public val Res.string.final_inspection_fail: StringResource by lazy {
      StringResource("string:final_inspection_fail", "final_inspection_fail", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13001, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11341, 81),
      ))
    }

public val Res.string.fly_high_plan_description: StringResource by lazy {
      StringResource("string:fly_high_plan_description", "fly_high_plan_description", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13260, 161),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11568, 141),
      ))
    }

public val Res.string.forgot_password: StringResource by lazy {
      StringResource("string:forgot_password", "forgot_password", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13422, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11710, 47),
      ))
    }

public val Res.string.forgot_your_password: StringResource by lazy {
      StringResource("string:forgot_your_password", "forgot_your_password", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13474, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11758, 56),
      ))
    }

public val Res.string.free: StringResource by lazy {
      StringResource("string:free", "free", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13826, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12098, 20),
      ))
    }

public val Res.string.free_100: StringResource by lazy {
      StringResource("string:free_100", "free_100", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13547, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11815, 108),
      ))
    }

public val Res.string.free_hundred: StringResource by lazy {
      StringResource("string:free_hundred", "free_hundred", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13668, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11924, 32),
      ))
    }

public val Res.string.freebie_plan_description: StringResource by lazy {
      StringResource("string:freebie_plan_description", "freebie_plan_description", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13705, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11957, 140),
      ))
    }

public val Res.string.friday: StringResource by lazy {
      StringResource("string:friday", "friday", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13851, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12119, 22),
      ))
    }

public val Res.string.from_phone: StringResource by lazy {
      StringResource("string:from_phone", "from_phone", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13878, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12142, 42),
      ))
    }

public val Res.string.from_small_teams: StringResource by lazy {
      StringResource("string:from_small_teams", "from_small_teams", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 13929, 252),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12185, 232),
      ))
    }

public val Res.string.full_name: StringResource by lazy {
      StringResource("string:full_name", "full_name", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14346, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12546, 29),
      ))
    }

public val Res.string.full_name_contact_person: StringResource by lazy {
      StringResource("string:full_name_contact_person", "full_name_contact_person", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14182, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12418, 68),
      ))
    }

public val Res.string.full_name_required: StringResource by lazy {
      StringResource("string:full_name_required", "full_name_required", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14267, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12487, 58),
      ))
    }

public val Res.string.galactic_plan_description: StringResource by lazy {
      StringResource("string:galactic_plan_description", "galactic_plan_description", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14392, 161),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12576, 141),
      ))
    }

public val Res.string.health_confirmation: StringResource by lazy {
      StringResource("string:health_confirmation", "health_confirmation", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14554, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12718, 67),
      ))
    }

public val Res.string.hello: StringResource by lazy {
      StringResource("string:hello", "hello", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14638, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12786, 21),
      ))
    }

public val Res.string.high_five_plan_description: StringResource by lazy {
      StringResource("string:high_five_plan_description", "high_five_plan_description", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14660, 126),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12808, 126),
      ))
    }

public val Res.string.hour: StringResource by lazy {
      StringResource("string:hour", "hour", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14787, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12935, 20),
      ))
    }

public val Res.string.images: StringResource by lazy {
      StringResource("string:images", "images", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14808, 22),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12956, 22),
      ))
    }

public val Res.string.import_list: StringResource by lazy {
      StringResource("string:import_list", "import_list", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14831, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 12979, 35),
      ))
    }

public val Res.string.inactive: StringResource by lazy {
      StringResource("string:inactive", "inactive", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14875, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13015, 28),
      ))
    }

public val Res.string.industry: StringResource by lazy {
      StringResource("string:industry", "industry", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14904, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13044, 28),
      ))
    }

public val Res.string.its: StringResource by lazy {
      StringResource("string:its", "its", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14933, 19),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13073, 19),
      ))
    }

public val Res.string.january: StringResource by lazy {
      StringResource("string:january", "january", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14953, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13093, 27),
      ))
    }

public val Res.string.job: StringResource by lazy {
      StringResource("string:job", "job", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16241, 15),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14301, 15),
      ))
    }

public val Res.string.job_added: StringResource by lazy {
      StringResource("string:job_added", "job_added", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15048, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13184, 49),
      ))
    }

public val Res.string.job_added_successfully: StringResource by lazy {
      StringResource("string:job_added_successfully", "job_added_successfully", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 14977, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13121, 62),
      ))
    }

public val Res.string.job_deleted: StringResource by lazy {
      StringResource("string:job_deleted", "job_deleted", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15106, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13234, 51),
      ))
    }

public val Res.string.job_details: StringResource by lazy {
      StringResource("string:job_details", "job_details", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15162, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13286, 35),
      ))
    }

public val Res.string.job_duration: StringResource by lazy {
      StringResource("string:job_duration", "job_duration", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15198, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13322, 36),
      ))
    }

public val Res.string.job_end_time_error: StringResource by lazy {
      StringResource("string:job_end_time_error", "job_end_time_error", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15231, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13359, 62),
      ))
    }

public val Res.string.job_finished: StringResource by lazy {
      StringResource("string:job_finished", "job_finished", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15298, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13422, 56),
      ))
    }

public val Res.string.job_rejected: StringResource by lazy {
      StringResource("string:job_rejected", "job_rejected", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15359, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13479, 48),
      ))
    }

public val Res.string.job_schedule: StringResource by lazy {
      StringResource("string:job_schedule", "job_schedule", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15408, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13528, 36),
      ))
    }

public val Res.string.job_start_time_error: StringResource by lazy {
      StringResource("string:job_start_time_error", "job_start_time_error", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15445, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13565, 64),
      ))
    }

public val Res.string.job_status: StringResource by lazy {
      StringResource("string:job_status", "job_status", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15835, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13923, 34),
      ))
    }

public val Res.string.job_status_cancelled: StringResource by lazy {
      StringResource("string:job_status_cancelled", "job_status_cancelled", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15518, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13630, 40),
      ))
    }

public val Res.string.job_status_completed: StringResource by lazy {
      StringResource("string:job_status_completed", "job_status_completed", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15563, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13671, 40),
      ))
    }

public val Res.string.job_status_draft: StringResource by lazy {
      StringResource("string:job_status_draft", "job_status_draft", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15612, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13712, 32),
      ))
    }

public val Res.string.job_status_in_progress: StringResource by lazy {
      StringResource("string:job_status_in_progress", "job_status_in_progress", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15649, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13745, 46),
      ))
    }

public val Res.string.job_status_on_hold: StringResource by lazy {
      StringResource("string:job_status_on_hold", "job_status_on_hold", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15700, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13792, 38),
      ))
    }

public val Res.string.job_status_open: StringResource by lazy {
      StringResource("string:job_status_open", "job_status_open", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15739, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13831, 31),
      ))
    }

public val Res.string.job_status_pending_approval: StringResource by lazy {
      StringResource("string:job_status_pending_approval", "job_status_pending_approval", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15771, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13863, 59),
      ))
    }

public val Res.string.job_title: StringResource by lazy {
      StringResource("string:job_title", "job_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15985, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14061, 29),
      ))
    }

public val Res.string.job_title_mandatory: StringResource by lazy {
      StringResource("string:job_title_mandatory", "job_title_mandatory", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15866, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 13958, 43),
      ))
    }

public val Res.string.job_title_required: StringResource by lazy {
      StringResource("string:job_title_required", "job_title_required", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 15910, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14002, 58),
      ))
    }

public val Res.string.job_updated: StringResource by lazy {
      StringResource("string:job_updated", "job_updated", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16088, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14156, 51),
      ))
    }

public val Res.string.job_updated_successfully: StringResource by lazy {
      StringResource("string:job_updated_successfully", "job_updated_successfully", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16015, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14091, 64),
      ))
    }

public val Res.string.jobs: StringResource by lazy {
      StringResource("string:jobs", "jobs", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16220, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14280, 20),
      ))
    }

public val Res.string.jobs_list: StringResource by lazy {
      StringResource("string:jobs_list", "jobs_list", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16148, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14208, 29),
      ))
    }

public val Res.string.jobs_overview: StringResource by lazy {
      StringResource("string:jobs_overview", "jobs_overview", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16178, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14238, 41),
      ))
    }

public val Res.string.join_good_job: StringResource by lazy {
      StringResource("string:join_good_job", "join_good_job", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16257, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14317, 41),
      ))
    }

public val Res.string.join_us: StringResource by lazy {
      StringResource("string:join_us", "join_us", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16307, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14359, 55),
      ))
    }

public val Res.string.july: StringResource by lazy {
      StringResource("string:july", "july", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16359, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14415, 20),
      ))
    }

public val Res.string.june: StringResource by lazy {
      StringResource("string:june", "june", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16380, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14436, 20),
      ))
    }

public val Res.string.keep_my_subscription: StringResource by lazy {
      StringResource("string:keep_my_subscription", "keep_my_subscription", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16401, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14457, 56),
      ))
    }

public val Res.string.last_accessed: StringResource by lazy {
      StringResource("string:last_accessed", "last_accessed", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16462, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14514, 41),
      ))
    }

public val Res.string.leave_details: StringResource by lazy {
      StringResource("string:leave_details", "leave_details", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16508, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14556, 41),
      ))
    }

public val Res.string.lets_get_to_work: StringResource by lazy {
      StringResource("string:lets_get_to_work", "lets_get_to_work", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16550, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14598, 52),
      ))
    }

public val Res.string.location: StringResource by lazy {
      StringResource("string:location", "location", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16883, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14899, 28),
      ))
    }

public val Res.string.location_details: StringResource by lazy {
      StringResource("string:location_details", "location_details", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16599, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14651, 48),
      ))
    }

public val Res.string.locations_agenda: StringResource by lazy {
      StringResource("string:locations_agenda", "locations_agenda", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16822, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14842, 56),
      ))
    }

public val Res.string.locations_agenda_text: StringResource by lazy {
      StringResource("string:locations_agenda_text", "locations_agenda_text", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16644, 177),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14700, 141),
      ))
    }

public val Res.string.log_out: StringResource by lazy {
      StringResource("string:log_out", "log_out", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16912, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14928, 27),
      ))
    }

public val Res.string.login_register: StringResource by lazy {
      StringResource("string:login_register", "login_register", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16940, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14956, 42),
      ))
    }

public val Res.string.login_to_access: StringResource by lazy {
      StringResource("string:login_to_access", "login_to_access", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 16991, 123),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 14999, 87),
      ))
    }

public val Res.string.logout: StringResource by lazy {
      StringResource("string:logout", "logout", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17115, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15087, 22),
      ))
    }

public val Res.string.manage_employees: StringResource by lazy {
      StringResource("string:manage_employees", "manage_employees", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17142, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15110, 100),
      ))
    }

public val Res.string.manage_subscription: StringResource by lazy {
      StringResource("string:manage_subscription", "manage_subscription", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17255, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15211, 59),
      ))
    }

public val Res.string.manager: StringResource by lazy {
      StringResource("string:manager", "manager", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17344, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15300, 27),
      ))
    }

public val Res.string.managers: StringResource by lazy {
      StringResource("string:managers", "managers", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17315, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15271, 28),
      ))
    }

public val Res.string.map: StringResource by lazy {
      StringResource("string:map", "map", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17372, 19),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15328, 15),
      ))
    }

public val Res.string.march: StringResource by lazy {
      StringResource("string:march", "march", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17392, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15344, 21),
      ))
    }

public val Res.string.mark_step_completed: StringResource by lazy {
      StringResource("string:mark_step_completed", "mark_step_completed", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17414, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15366, 51),
      ))
    }

public val Res.string.mark_step_pending: StringResource by lazy {
      StringResource("string:mark_step_pending", "mark_step_pending", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17482, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15418, 41),
      ))
    }

public val Res.string.max_size: StringResource by lazy {
      StringResource("string:max_size", "max_size", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17540, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15460, 52),
      ))
    }

public val Res.string.may: StringResource by lazy {
      StringResource("string:may", "may", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17597, 15),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15513, 15),
      ))
    }

public val Res.string.members: StringResource by lazy {
      StringResource("string:members", "members", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17613, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15529, 27),
      ))
    }

public val Res.string.minute: StringResource by lazy {
      StringResource("string:minute", "minute", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17673, 22),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15585, 22),
      ))
    }

public val Res.string.minutes: StringResource by lazy {
      StringResource("string:minutes", "minutes", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17645, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15557, 27),
      ))
    }

public val Res.string.monday: StringResource by lazy {
      StringResource("string:monday", "monday", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17696, 22),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15608, 22),
      ))
    }

public val Res.string.month: StringResource by lazy {
      StringResource("string:month", "month", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17781, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15693, 21),
      ))
    }

public val Res.string.month_capitalized: StringResource by lazy {
      StringResource("string:month_capitalized", "month_capitalized", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17719, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15631, 33),
      ))
    }

public val Res.string.monthly: StringResource by lazy {
      StringResource("string:monthly", "monthly", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17753, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15665, 27),
      ))
    }

public val Res.string.most_popular: StringResource by lazy {
      StringResource("string:most_popular", "most_popular", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17803, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15715, 36),
      ))
    }

public val Res.string.name: StringResource by lazy {
      StringResource("string:name", "name", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17844, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15752, 20),
      ))
    }

public val Res.string.need_an_account: StringResource by lazy {
      StringResource("string:need_an_account", "need_an_account", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17865, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15773, 47),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString2Resources(map: MutableMap<String, StringResource>) {
  map.put("feedback", Res.string.feedback)
  map.put("file_added", Res.string.file_added)
  map.put("file_deleted", Res.string.file_deleted)
  map.put("file_empty", Res.string.file_empty)
  map.put("files", Res.string.files)
  map.put("files_notes", Res.string.files_notes)
  map.put("files_skipped_message", Res.string.files_skipped_message)
  map.put("files_skipped_title", Res.string.files_skipped_title)
  map.put("filter", Res.string.filter)
  map.put("filter_empty", Res.string.filter_empty)
  map.put("final_inspection", Res.string.final_inspection)
  map.put("final_inspection_desc", Res.string.final_inspection_desc)
  map.put("final_inspection_fail", Res.string.final_inspection_fail)
  map.put("fly_high_plan_description", Res.string.fly_high_plan_description)
  map.put("forgot_password", Res.string.forgot_password)
  map.put("forgot_your_password", Res.string.forgot_your_password)
  map.put("free", Res.string.free)
  map.put("free_100", Res.string.free_100)
  map.put("free_hundred", Res.string.free_hundred)
  map.put("freebie_plan_description", Res.string.freebie_plan_description)
  map.put("friday", Res.string.friday)
  map.put("from_phone", Res.string.from_phone)
  map.put("from_small_teams", Res.string.from_small_teams)
  map.put("full_name", Res.string.full_name)
  map.put("full_name_contact_person", Res.string.full_name_contact_person)
  map.put("full_name_required", Res.string.full_name_required)
  map.put("galactic_plan_description", Res.string.galactic_plan_description)
  map.put("health_confirmation", Res.string.health_confirmation)
  map.put("hello", Res.string.hello)
  map.put("high_five_plan_description", Res.string.high_five_plan_description)
  map.put("hour", Res.string.hour)
  map.put("images", Res.string.images)
  map.put("import_list", Res.string.import_list)
  map.put("inactive", Res.string.inactive)
  map.put("industry", Res.string.industry)
  map.put("its", Res.string.its)
  map.put("january", Res.string.january)
  map.put("job", Res.string.job)
  map.put("job_added", Res.string.job_added)
  map.put("job_added_successfully", Res.string.job_added_successfully)
  map.put("job_deleted", Res.string.job_deleted)
  map.put("job_details", Res.string.job_details)
  map.put("job_duration", Res.string.job_duration)
  map.put("job_end_time_error", Res.string.job_end_time_error)
  map.put("job_finished", Res.string.job_finished)
  map.put("job_rejected", Res.string.job_rejected)
  map.put("job_schedule", Res.string.job_schedule)
  map.put("job_start_time_error", Res.string.job_start_time_error)
  map.put("job_status", Res.string.job_status)
  map.put("job_status_cancelled", Res.string.job_status_cancelled)
  map.put("job_status_completed", Res.string.job_status_completed)
  map.put("job_status_draft", Res.string.job_status_draft)
  map.put("job_status_in_progress", Res.string.job_status_in_progress)
  map.put("job_status_on_hold", Res.string.job_status_on_hold)
  map.put("job_status_open", Res.string.job_status_open)
  map.put("job_status_pending_approval", Res.string.job_status_pending_approval)
  map.put("job_title", Res.string.job_title)
  map.put("job_title_mandatory", Res.string.job_title_mandatory)
  map.put("job_title_required", Res.string.job_title_required)
  map.put("job_updated", Res.string.job_updated)
  map.put("job_updated_successfully", Res.string.job_updated_successfully)
  map.put("jobs", Res.string.jobs)
  map.put("jobs_list", Res.string.jobs_list)
  map.put("jobs_overview", Res.string.jobs_overview)
  map.put("join_good_job", Res.string.join_good_job)
  map.put("join_us", Res.string.join_us)
  map.put("july", Res.string.july)
  map.put("june", Res.string.june)
  map.put("keep_my_subscription", Res.string.keep_my_subscription)
  map.put("last_accessed", Res.string.last_accessed)
  map.put("leave_details", Res.string.leave_details)
  map.put("lets_get_to_work", Res.string.lets_get_to_work)
  map.put("location", Res.string.location)
  map.put("location_details", Res.string.location_details)
  map.put("locations_agenda", Res.string.locations_agenda)
  map.put("locations_agenda_text", Res.string.locations_agenda_text)
  map.put("log_out", Res.string.log_out)
  map.put("login_register", Res.string.login_register)
  map.put("login_to_access", Res.string.login_to_access)
  map.put("logout", Res.string.logout)
  map.put("manage_employees", Res.string.manage_employees)
  map.put("manage_subscription", Res.string.manage_subscription)
  map.put("manager", Res.string.manager)
  map.put("managers", Res.string.managers)
  map.put("map", Res.string.map)
  map.put("march", Res.string.march)
  map.put("mark_step_completed", Res.string.mark_step_completed)
  map.put("mark_step_pending", Res.string.mark_step_pending)
  map.put("max_size", Res.string.max_size)
  map.put("may", Res.string.may)
  map.put("members", Res.string.members)
  map.put("minute", Res.string.minute)
  map.put("minutes", Res.string.minutes)
  map.put("monday", Res.string.monday)
  map.put("month", Res.string.month)
  map.put("month_capitalized", Res.string.month_capitalized)
  map.put("monthly", Res.string.monthly)
  map.put("most_popular", Res.string.most_popular)
  map.put("name", Res.string.name)
  map.put("need_an_account", Res.string.need_an_account)
}
